
// import React from 'react'
import { Route, Routes } from 'react-router-dom';
// import { useRoutes } from "react-router-dom";
import { URLS } from '../resources/constants';

import COAExixts from '../hoc/COAExixts';
import MonthCloseDepositSalesPos from '../hoc/MonthCloseDepositSalesPos';
import PrivateRoutes from '../hoc/PrivateRoutes';
import UserMappedRoutes from '../hoc/UserMappedAccount';
import Header from '../layouts/Header';
import BalanceSheet from '../scenes/BalanceSheet';
import Budget from '../scenes/Budget';
import BudgetVsActual from '../scenes/BudgetVsActual';
import ChartOfAccounts from '../scenes/ChartOfAccounts';
import Dashboard from '../scenes/Dashboard';
import CreditCardGlClassification from '../scenes/GlClassification/CreditCardGlClassification/CreditCardGlClassification';
import CreditCardGlClassificationStatus from '../scenes/GlClassification/CreditCardGlClassification/CreditCardGlClassificationStatus';
import ExpenseGlClassification from '../scenes/GlClassification/ExpenseGlClassification/ExpenseGlClassification';
import ExpenseGlClassificationStatus from '../scenes/GlClassification/ExpenseGlClassification/ExpenseGlClassificationStatus';
import RevenueGlClassification from '../scenes/GlClassification/RevenueGlClassification/RevenueGlClassification';
import RevenueGlClassificationStatus from '../scenes/GlClassification/RevenueGlClassification/RevenueGlClassificationStatus';
import Login from '../scenes/Login';
import Settings from '../scenes/Settings';
import BankTransaction from '../scenes/Transactions/BankTransactions';
import UserProfile from '../scenes/UserProfile';
import UserVerification from '../scenes/UserVerification';
// import CreditGlClassification from '../scenes/GlClassification/CreditGlClassification';
import TaxForms from 'scenes/TaxResolution/TaxForms/Index';
import UserStpesRoutes from '../hoc/UserStpesCheck';
import BankReconcile from '../scenes/BankReconcile';
import BankReconcileTxn from '../scenes/BankReconcile/BankReconcileTxn';
import BusinessRatio from '../scenes/BusinesssRatio';
import FourThreeThreeB from '../scenes/FourThreeThreeB';
import BankFeed from '../scenes/GlClassification/BankFeed';
import DepositGlClassification from '../scenes/GlClassification/DepositGlClassification/DepositGlClassification';
import DepositGlClassificationStatus from '../scenes/GlClassification/DepositGlClassification/DepositGlClassificationStatus';
import ViewRegister from '../scenes/GlClassification/ViewRegister';
import NotFound from '../scenes/NotFound';
import OpenningBalance from '../scenes/OpenningBalance';
import PersonalBalanceSheet from '../scenes/PersonalBalanceSheet';
import PersonalIncomeStatement from '../scenes/PersonalIncomeStatement';
import ProfitLoss from '../scenes/ProfitLoss';
import Sales from '../scenes/Sales';
import StatementOfCashFlow from '../scenes/StatementOfCashFlow';
import ThirdPartyIntegrationList from '../scenes/ThirdParty';
import ThirdPartyConnection from '../scenes/ThirdParty/Connection';
import QBBeginningBalanceClassification from '../scenes/ThirdParty/QuickBook/BBClassification';
import QuickBookDashboard from '../scenes/ThirdParty/QuickBook/Dashboard';
import QBBalanceSheetPLList from '../scenes/ThirdParty/QuickBook/QBBalanceSheetPLList';
import QBBSList from '../scenes/ThirdParty/QuickBook/QBBSList';
import QBCOAClassification from '../scenes/ThirdParty/QuickBook/QBCOAClassification';
import QboBackupStatusPage from '../scenes/ThirdParty/QuickBook/QboBackupStatusPage';
import QBPLList from '../scenes/ThirdParty/QuickBook/QBPLList';
import QBVendorList from '../scenes/ThirdParty/QuickBook/QBVendorList';
import QBCustomerList from '../scenes/ThirdParty/QuickBook/QBCustomerList';
import Tax1099Vendors from '../scenes/Tax1099Vendors';
import Tax1099PayeeReview from '../scenes/Tax1099PayeeReview';
import Tax1099Payments from '../scenes/Tax1099Payments';
import Tax1099Forms from '../scenes/Tax1099Forms';
import Tax1099PayerSettings from '../scenes/Tax1099PayerSettings';
import Tax1099Portfolio from '../scenes/Tax1099Portfolio';
import Tax1099ExpenseSync from '../scenes/Tax1099ExpenseSync';
import Tax1099YearEndReview from '../scenes/Tax1099YearEndReview';
import Tax1099Layout from '../layouts/Tax1099Layout';
import QuickBookCallback from '../scenes/ThirdParty/QuickBookCallback';
import SaleTransaction from '../scenes/Transactions/SalesTransactions';
import FormFourThreeThreeB from 'scenes/TaxResolution/FormFourThreeThreeB/Index';

const Router: React.FC = () => {
    return (
        <div style={{ height: '100vh'}}>
            <Routes>
                <Route element={<PrivateRoutes />}>
                    <Route element={<Header />} path="/">
                        <Route element={<Dashboard />} path={URLS.HOME} />
                        <Route element={<Dashboard />} path={URLS.DASHBOARD} />
                        <Route element={<Tax1099Layout />}>
                            <Route element={<Tax1099Portfolio />} path={URLS.TAX_1099_PORTFOLIO} />
                            <Route element={<Tax1099Forms />} path={URLS.TAX_1099_FORMS} />
                            <Route element={<Tax1099Vendors />} path={URLS.TAX_1099_VENDORS} />
                            <Route element={<Tax1099Vendors />} path={URLS.VENDOR_CENTER} />
                            <Route element={<Tax1099Vendors />} path={URLS.QBO_VENDORS} />
                            <Route element={<Tax1099ExpenseSync />} path={URLS.TAX_1099_EXPENSE_SYNC} />
                            <Route element={<Tax1099PayeeReview />} path={URLS.TAX_1099_PAYEE_REVIEW} />
                            <Route element={<Tax1099Payments />} path={URLS.TAX_1099_PAYMENTS} />
                            <Route element={<Tax1099YearEndReview />} path={URLS.TAX_1099_YEAR_END_REVIEW} />
                            <Route element={<Tax1099PayerSettings />} path={URLS.TAX_1099_PAYER_SETTINGS} />
                        </Route>
                        {/* <Route element={<VersionUpgrade />}> */}
                            <Route element={<COAExixts />}>
                                <Route element={<OpenningBalance />} path={URLS.OPENNING_BALANCE} />
                                {/* <Route element={<BeginingBalanceExixts />}> */}
                                <Route element={<MonthCloseDepositSalesPos />}>
                                    <Route element={<UserStpesRoutes />}>
                                        <Route element={<BankTransaction />} path={URLS.BANK_TRANSACTION} />
                                        <Route element={<UserProfile />} path={URLS.USERPROFILE} />
                                        <Route element={<Settings />} path={URLS.SETTINGS} />
                                        <Route element={<BalanceSheet />} path={URLS.BALANCESHEET} />
                                        <Route element={<Budget />} path={URLS.BUDGET} />
                                        <Route element={<BudgetVsActual />} path={URLS.BUDGET_VS_ACTUAL} />
                                        <Route element={<BankFeed />} path={URLS.BANK_FEED} />
                                        <Route element={<SaleTransaction />} path={URLS.SALES_TRANSACTION} />
                                        <Route element={<ViewRegister />} path={URLS.VIEW_REGISTER} />
                                        <Route element={<ProfitLoss />} path={URLS.PROFITLOSS} />
                                        <Route element={<FourThreeThreeB />} path={URLS.FOURTHREETHREEB} />
                                        <Route element={<PersonalBalanceSheet />} path={URLS.PERSONAL_BALANCE_SHEET} />
                                        <Route element={<PersonalIncomeStatement />} path={URLS.PERSONAL_INCOME_STATMENT} />
                                        <Route element={<StatementOfCashFlow />} path={URLS.STATEMENT_OF_CASH_FLOW} />
                                        <Route element={<BankReconcile />} path={URLS.BANK_RECONCILE} />
                                        <Route element={<BankReconcileTxn />} path={URLS.BANK_RECONCILE_TRANSACTIONS} />
                                        <Route element={<BusinessRatio />} path={URLS.BUSINESS_RATIO} />
                                        <Route element={<Sales />} path={URLS.SALES} />
                                        <Route element={<QBCustomerList />} path={URLS.QBO_CUSTOMERS} />
                                        <Route element={<TaxForms />} path={URLS.TAX_RESOLUTION_FORMS} />
                                        <Route element={<FormFourThreeThreeB />} path={URLS.TAX_FORM_433B} />
                                    </Route>
                                    <Route element={<UserMappedRoutes />}>
                                        <Route element={<ExpenseGlClassification />} path={URLS.EXPENSE_GL_CLASSIFICATION} />
                                        <Route element={<ExpenseGlClassificationStatus />} path={URLS.EXPENSE_GL_CLASSIFICATION_STATUS} />

                                        <Route element={<DepositGlClassification />} path={URLS.DEPOSIT_GL_CLASSIFICATION} />
                                        <Route element={<DepositGlClassificationStatus />} path={URLS.DEPOSIT_GL_CLASSIFICATION_STATUS} />

                                        <Route element={<CreditCardGlClassificationStatus/>} path={URLS.CREDIT_CARD_GL_CLASSIFICATION_STATUS} />
                                        <Route element={<CreditCardGlClassification/>} path={URLS.CREDIT_CARD_GL_CLASSIFICATION} />

                                        <Route element={<RevenueGlClassification />} path={URLS.REVENUE_GL_CLASSIFICATION} />
                                        <Route element={<RevenueGlClassificationStatus />} path={URLS.REVENUE_GL_CLASSIFICATION_STATUS} />
                                    </Route>
                                {/* </Route> */}
                                </Route>
                            </Route>
                            <Route element={<ChartOfAccounts />} path={URLS.CHARTACCOUNT} />
                        {/* </Route> */}
                        <Route element={<ThirdPartyIntegrationList />} path={URLS.THIRD_PARTY} />
                        <Route element={<ThirdPartyConnection />} path={URLS.THIRD_PARTY_CONNECTION} />
                        <Route element={<QuickBookDashboard />} path={URLS.QUICKBOOK_DASHBOARD} />
                        <Route element={<QBCOAClassification />} path={URLS.QUICKBOOK_COA} />
                        <Route element={<QBBeginningBalanceClassification />} path={URLS.QUICKBOOK_BB} />
                        <Route element={<QBBalanceSheetPLList />} path={URLS.QUICKBOOK_BS_PL} />
                        <Route element={<QBBSList />} path={URLS.QUICKBOOK_BS} />
                        <Route element={<QBPLList />} path={URLS.QUICKBOOK_PL} />
                        <Route element={<QboBackupStatusPage />} path={URLS.QBO_BACKUP_STATUS_PAGE} />
                        <Route element={<QuickBookCallback />} path={URLS.QUICKBOOK_CALLBACK} />
                    </Route>
                </Route>
                <Route element={<Login />} path={URLS.LOGIN} />
                <Route element={<UserVerification />} path={URLS.USER_VERIFICATION} />
                <Route path='*' element={<NotFound />} />
                <Route path={URLS.PAGE_NOT_FOUND} element={<NotFound />} />
            </Routes>
        </div>
    )
}

export default Router;
